import React, { useState, useEffect } from "react";
import { loadHighScores, HighScoreEntry } from "../../../utils/highScores";
import "../../ResultScreen.css";

interface HighScoreTableProps {
  highScoreRank: number;
}

const HighScoreTable: React.FC<HighScoreTableProps> = ({ highScoreRank }) => {
  const [highScores, setHighScores] = useState<HighScoreEntry[]>([]);

  useEffect(() => {
    const scores = loadHighScores();
    setHighScores(scores);
  }, []);

  const formatStat = (value: number): string => {
    return value.toLocaleString();
  };

  return (
    <div className="result-screen-table-container">
      <div className="result-screen-highscore-content">
        {highScoreRank !== -1 && (
          <div className="result-screen-highscore-new-entry">
            <h3>🎉 New High Score! Rank #{highScoreRank + 1}</h3>
          </div>
        )}

        <div className="result-screen-highscore-list">
          {highScores.length === 0 ? (
            <p className="no-scores">No high scores yet</p>
          ) : (
            <table className="result-screen-table">
              <thead>
                <tr>
                  <th className="result-col-stat">Rank</th>
                  <th className="result-col-player">Name</th>
                  <th className="result-col-stat">Score</th>
                  <th className="result-col-stat">Level</th>
                  <th className="result-col-stat">Lines</th>
                </tr>
              </thead>
              <tbody>
                {highScores.map((entry, index) => (
                  <tr
                    key={index}
                    className={index === highScoreRank ? "new-high-score" : ""}
                  >
                    <td className="result-col-stat">{index + 1}</td>
                    <td className="result-col-player">{entry.name}</td>
                    <td className="result-col-stat">{formatStat(entry.score)}</td>
                    <td className="result-col-stat">{entry.level}</td>
                    <td className="result-col-stat">{formatStat(entry.lines)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default HighScoreTable;

